// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { mergeWithCss } from "@keller/XDL/Utilities";
import { css } from "styled-components";

const xPartNumberStyle: {
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
    labelWithoutDot?: TypographyPresentationProps;
} = {
    label: {
        size: 12,
        weight: "bold",
        transform: "capitalize",
        css: css`
            letter-spacing: 0;
            line-height: 18px;
            margin-right: 4px;
            margin-bottom: 0;
            flex-shrink: 0;
            display: inline-block;
            &:after {
                content: ":";
            }
        `,
    },
    value: {
        size: 12,
        weight: "normal",
        css: css`
            letter-spacing: 0;
            line-height: 18px;
        `,
    },
};

xPartNumberStyle.labelWithoutDot = mergeWithCss(xPartNumberStyle.label, {
    css: css`
        &:after {
            display: none;
        }
    `,
});

export { xPartNumberStyle };
